import { Quote, QuotesState } from 'acscp/store';

export const getBookingQuotes = (quotes: QuotesState, bookingId: string | undefined | null) => {
    if (!bookingId) {
        return [];
    }

    return Object.keys(quotes.quotesList)
        .map(id => quotes.quotesList[id])
        .filter(q => q.bookingId === bookingId)
        .sort((quote1, quote2) => quote1.order - quote2.order);
};
